import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ColumnModel, PageSettingsModel, GroupSettingsModel } from '@syncfusion/ej2-angular-grids';
import Swal from 'sweetalert2';
import { codigosCodVenTotvs } from 'src/app/classes/Fazenda';
import { Fazenda } from 'src/app/classes/Fazenda';
import { Area } from 'src/app/classes/Area';
import { Setor } from 'src/app/classes/Setor';
import { Gleba } from 'src/app/classes/Gleba';
import { AreaService } from 'src/app/services/area.service';
import { GlebaService } from 'src/app/services/gleba.service';
import { SetorService } from 'src/app/services/setor.service';
import { FazendaService } from 'src/app/services/fazenda.service';
import { StorageService } from 'src/app/services/storage.service';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { SyncGridComponent } from '../../../shared-farm/sync-grid/sync-grid.component';
import { enumErpIntegrado } from 'src/app/classes/Empresa';
import * as moment from 'moment';

@Component({
  selector: 'app-forms-fazenda',
  templateUrl: './forms-fazenda.component.html',
  styleUrls: ['./forms-fazenda.component.scss']
})
export class FormsFazendaComponent implements OnInit {

  @Input() fazendaId: number = 0;
  @Input() inserindo: boolean = false;
  @Output() finalizarSave: EventEmitter<void> = new EventEmitter();
  @Output() cancelarEvent: EventEmitter<void> = new EventEmitter();

  @ViewChild('formulario', { static: false }) formulario!: NgForm;
  @ViewChild('FormsArea', { static: false }) FormsArea: any;
  @ViewChild('FormsGleba', { static: false }) FormsGleba: any;
  @ViewChild('gridAreasIrrigado', { static: false }) gridAreasIrrigado: SyncGridComponent;
  @ViewChild('gridAreasSequeiro', { static: false }) gridAreasSequeiro: SyncGridComponent;

  fazenda: Fazenda = new Fazenda();

  carregando: boolean = false; // Loading do formulário da fazenda
  carregandoAreas: boolean = true; // Loading das grids de áreas
  inativandoAreas: boolean = false;
  removendoAreas: boolean = false;
  isSubmit: boolean = false;
  integraTotvs: boolean = false;
  integraSankhya: boolean = false;
  organizaPorSetor: boolean = false;
  codsCodVenTotvs = codigosCodVenTotvs;

  // Áreas
  areasIrrigado: Area[] = [];
  areasSequeiro: Area[] = [];
  auxAreas: Area[] = [];
  textoBuscaAreaIrrigado: string = "";
  textoBuscaAreaSequeiro: string = "";
  gbAreaId: number = 0;
  gbNomeArea: string = "";
  glebas: Gleba[] = [];

  // Setores
  setoresAux: Setor[] = [];
  setoresIrrigado: Setor[] = [];
  setoresSequeiro: Setor[] = [];

  // Grids
  areaColumns: ColumnModel[] = [];
  gridHeight: string = '400px';
  pageSettings: PageSettingsModel = {
    pageSizes: [10, 20, 30, 40, 50, 100],
    pageSize: 20,
    pageCount: 4,
  };
  groupSettings: GroupSettingsModel = {
    columns: ['SetorDescricao']
  };

  // Traduções
  ERRO: string = 'Erro!';
  FEITO: string = 'Feito!';
  SIM: string = 'Sim';
  CANCELAR: string = 'Cancelar';
  SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA: string = 'Se deletar, esta ação não poderá ser desfeita!';
  AREA_DELETADA: string = 'Área deletada';
  AREA_CADASTRADA: string = 'Área cadastrada!';
  AREA_ALTERADA: string = 'Área alterada!';
  FAZENDA_DELETADA: string = 'Fazenda deletada!';
  FAZENDA_CADASTRADA: string = 'Fazenda cadastrada!';
  FAZENDA_ALTERADA: string = 'Fazenda Alterada!';
  SETOR_DELETADO: string = 'Setor deletado!';
  SETOR_CADASTRADO: string = 'Setor cadastrado!';
  SETOR_ALTERADO: string = 'Setor alterado';
  GLEBA_DELETADA: string = 'Gleba deletada!';
  GLEBA_CADASTRADA: string = 'Gleba cadastrada!';
  GLEBA_ALTERADA: string = 'Gleba alterada!';
  NENHUMA_AREA_INFORMADA: string = 'Nenhuma área informada';

  constructor(
    private fazendaService: FazendaService,
    private areaService: AreaService,
    private glebaService: GlebaService,
    private setorService: SetorService,
    private utils: UtilsService,
    private translate: TranslateService,
    private storageService: StorageService,
    private toasty: CustomToastyService,
    private router: Router
  ) {}

  ngOnInit() {
    this.integraTotvs = this.storageService.getEmpresa().ErpIntegrado == enumErpIntegrado.Totvs_RM;
    this.integraSankhya = this.storageService.getEmpresa().ErpIntegrado == enumErpIntegrado.Sankhya;
    this.organizaPorSetor = this.storageService.getEmpresa().UsaSetores;
    this.configurarTraducao();
    this.configurarGrids();

    if (this.fazendaId > 0) {
      this.carregarFazenda();
    } else {
      this.fazenda = new Fazenda();
      this.carregandoAreas = false;
    }
  }

  configurarTraducao() {
    this.ERRO = this.translate.instant('ERRO');
    this.FEITO = this.translate.instant('FEITO');
    this.SIM = this.translate.instant('SIM');
    this.CANCELAR = this.translate.instant('CANCELAR');
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = this.translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA');
    this.AREA_DELETADA = this.translate.instant('AREA_DELETADA');
    this.AREA_CADASTRADA = this.translate.instant('AREA_CADASTRADA');
    this.AREA_ALTERADA = this.translate.instant('AREA_ALTERADA');
    this.FAZENDA_DELETADA = this.translate.instant('FAZENDA_DELETADA');
    this.FAZENDA_CADASTRADA = this.translate.instant('FAZENDA_CADASTRADA');
    this.FAZENDA_ALTERADA = this.translate.instant('FAZENDA_ALTERADA');
    this.SETOR_DELETADO = this.translate.instant('SETOR_DELETADO');
    this.SETOR_CADASTRADO = this.translate.instant('SETOR_CADASTRADO');
    this.SETOR_ALTERADO = this.translate.instant('SETOR_ALTERADO');
    this.GLEBA_DELETADA = this.translate.instant('GLEBA_DELETADA');
    this.GLEBA_CADASTRADA = this.translate.instant('GLEBA_CADASTRADA');
    this.GLEBA_ALTERADA = this.translate.instant('GLEBA_ALTERADA');
    this.NENHUMA_AREA_INFORMADA = this.translate.instant('NENHUMA_AREA_INFORMADA');
  }

  configurarGrids() {
    this.areaColumns = [
      { type: "checkbox", width: 50, showInColumnChooser: false},
      {
        field: "SetorDescricao",
        headerText: 'Setor',
        type: "string",
        allowSorting: true,
        visible: false,
        showInColumnChooser: this.organizaPorSetor
      },
      {
        field: "Descricao",
        headerText: 'Nome',
        type: "string",
        allowSorting: true,
      },
      {
        field: "AreaTotal",
        headerText: 'Area',
        type: "number",
        allowSorting: true,
        format: 'N2'
      },
      {
        field: "Sigla",
        headerText: 'Sigla',
        type: "string",
        allowSorting: true,
      },
      {
        field: "dataAlteracaoStr",
        headerText: "Ult. Mod.",
        type: "string",
        allowSorting: true,
        sortComparer: (a: string, b: string) => {
          return moment(a, 'DD/MM/YYYY HH:mm').diff(moment(b, 'DD/MM/YYYY HH:mm'));
        }
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "descAtivo",
        headerText: 'Status',
        type: "boolean",
        allowSorting: true,
        disableHtmlEncode: false,
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatusArea(_data.Ativo);
        }
      } as ColumnModel
    ];
  }

  badgeStatusArea(ativo: boolean): string {
    return ativo
      ? '<span class="badge badge-light-success">' + this.translate.instant('ATIVO') + '</span>'
      : '<span class="badge badge-light-danger">' + this.translate.instant('INATIVO') + '</span>'
  }

  carregarFazenda() {
    this.carregando = true;
    this.fazendaService.getFazenda(this.fazendaId).subscribe(res => {
      this.fazenda = new Fazenda();
      this.fazenda = res;
      // Carregar setores primeiro, depois áreas
      this.listarSetores(true);
    },
    ex => {
      Swal.fire(this.ERRO, ex.error.ExceptionMessage, 'error');
      this.carregando = false;
    });
  }


  listarSetores(listarAreas: boolean = false) : void{
    this.setorService.getSetoresPorFazenda(this.fazendaId).subscribe(setores => {
      this.setoresAux = setores;
      this.setoresIrrigado = setores.filter(x => x.Irrigado);
      this.setoresSequeiro = setores.filter(x => x.Sequeiro);

      // Agora carregar áreas
      if (listarAreas) {
        this.listarAreas(this.fazenda.Id);
      }
      this.carregando = false;
    }, err => {
      this.utils.getErro(err);
      this.carregando = false;
    });
  }

  save(form: any) {
    if (!form.valid) {
      this.isSubmit = true;
      return;
    }

    if (this.isLatitudeInvalida()) {
      this.isSubmit = true;
      Swal.fire(this.ERRO, 'A latitude deve estar entre -90 e 90', 'error');
      return;
    }

    if (this.isLongitudeInvalida()) {
      this.isSubmit = true;
      Swal.fire(this.ERRO, 'A longitude deve estar entre -180 e 180', 'error');
      return;
    }

    const permissaoNecessaria = this.fazenda.Id > 0 ? 'EditarFazenda' : 'IncluirFazenda';
    if (!this.utils.verificarPermissaoUsuario(permissaoNecessaria)) {
      return;
    }

    this.carregando = true;
    this.configurarTraducao();

    if (this.fazenda.Id > 0)
      this.fazendaService.putFazenda(this.fazenda.Id, this.fazenda).subscribe(
        res => {
          this.toasty.show(this.FEITO, this.FAZENDA_ALTERADA, 'success');
          this.carregando = false;
          this.finalizarSave.emit();
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
    else
      this.fazendaService.postFazenda(this.fazenda).subscribe(
        res => {
          this.toasty.show(this.FEITO, this.FAZENDA_CADASTRADA, 'success');
          this.carregando = false;
          this.fazenda.Id = res.Id;
          this.finalizarSave.emit();
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
  }

  cancelar() {
    this.cancelarEvent.emit();
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
    );
  }

  isLatitudeInvalida(): boolean {
    if (!this.fazenda.Latitude) {
      return false;
    }
    const latitude = parseFloat(this.fazenda.Latitude.toString().replace(',', '.'));
    return isNaN(latitude) || latitude < -90 || latitude > 90;
  }

  isLongitudeInvalida(): boolean {
    if (!this.fazenda.Longitude) {
      return false;
    }
    const longitude = parseFloat(this.fazenda.Longitude.toString().replace(',', '.'));
    return isNaN(longitude) || longitude < -180 || longitude > 180;
  }

  // ÁREAS
  inserirArea() {
    if (!this.utils.verificarPermissaoUsuario('IncluirArea')) {
      return;
    }

    if (this.FormsArea) {
      this.FormsArea.show();
    }
  }

  inserirAreaIrrigado() {
    if (!this.utils.verificarPermissaoUsuario('IncluirArea')) {
      return;
    }

    if (this.FormsArea) {
      this.FormsArea.show(undefined, true);
    }
  }

  inserirAreaSequeiro() {
    if (!this.utils.verificarPermissaoUsuario('IncluirArea')) {
      return;
    }

    if (this.FormsArea) {
      this.FormsArea.show(undefined, false);
    }
  }

  selecionarArea(idArea: number) {
    if (!this.utils.verificarPermissaoUsuario('EditarArea')) {
      return;
    }

    this.carregandoAreas = true;
    this.configurarTraducao();
    this.areaService.getArea(idArea).subscribe(res => {
      const area = res;
      this.carregandoAreas = false;
      if (this.FormsArea) {
        this.FormsArea.show(area);
      }
    },
    ex => {
      Swal.fire(this.ERRO, ex.error.ExceptionMessage, 'error');
      this.carregandoAreas = false;
    });
  }

  finalizarSaveArea() {
    this.listarAreas(this.fazenda.Id);
    this.selecionarAreas();
  }

  excluirArea(areaId: number, nome: string) {
    if (!this.utils.verificarPermissaoUsuario('ExcluirArea')) {
      return;
    }

    this.configurarTraducao();
    Swal.fire({
      title: 'Deletar ' + nome + '?',
      text: this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
        this.carregandoAreas = true;
        this.areaService.deleteArea(areaId).subscribe(
          res => {
            this.toasty.show(this.FEITO, this.AREA_DELETADA, 'success');
            this.listarAreas(this.fazenda.Id);
            this.selecionarAreas();
            this.carregandoAreas = false;
          },
          err => {
            this.utils.getErro(err);
            this.carregandoAreas = false;
          });
      }
    });
  }

  listarAreas(idFazenda: number) {
    this.carregandoAreas = true;
    this.configurarTraducao();
    this.areaService.listarTodasAreasPorFazenda(idFazenda).subscribe(
      res => {
        this.auxAreas =  res.map(u => Object.assign(new Area(), u));
        this.enriquecerAreasComSetor();
        this.carregandoAreas = false;
        this.filtrarAreasIrrigado();
        this.filtrarAreasSequeiro();
      },
      err => {
        this.utils.getErro(err);
        this.carregandoAreas = false;
      });
  }

  enriquecerAreasComSetor() {
    // Adiciona o nome do setor em cada área para permitir agrupamento
    this.auxAreas.forEach(area => {
      if (area.SetorId) {
        const setor = this.setoresAux.find(s => s.Id === area.SetorId);
        area['SetorDescricao'] = setor ? setor.Descricao : 'Não possui';
      } else {
        area['SetorDescricao'] = 'Não possui';
      }
    });
  }

  filtrarAreasIrrigado() {
    this.areasIrrigado = this.auxAreas.filter(x =>
      x.Irrigado &&
      (x.Descricao.toUpperCase().includes(this.textoBuscaAreaIrrigado.toUpperCase()) ||
        x.Id.toString().includes(this.textoBuscaAreaIrrigado) ||
        (x['SetorDescricao'] && x['SetorDescricao'].toUpperCase().includes(this.textoBuscaAreaIrrigado.toUpperCase())))
    );
    // Ordenar por setor primeiro, depois por descrição
    this.areasIrrigado.sort((a, b) => {
      const setorA = a['SetorDescricao'] || '';
      const setorB = b['SetorDescricao'] || '';
      if (setorA !== setorB) {
        return setorA.localeCompare(setorB);
      }
      return a.Descricao.localeCompare(b.Descricao);
    });
  }

  filtrarAreasSequeiro() {
    this.areasSequeiro = this.auxAreas.filter(x =>
      !x.Irrigado &&
      (x.Descricao.toUpperCase().includes(this.textoBuscaAreaSequeiro.toUpperCase()) ||
        x.Id.toString().includes(this.textoBuscaAreaSequeiro) ||
        (x['SetorDescricao'] && x['SetorDescricao'].toUpperCase().includes(this.textoBuscaAreaSequeiro.toUpperCase())))
    );
    // Ordenar por setor primeiro, depois por descrição
    this.areasSequeiro.sort((a, b) => {
      const setorA = a['SetorDescricao'] || '';
      const setorB = b['SetorDescricao'] || '';
      if (setorA !== setorB) {
        return setorA.localeCompare(setorB);
      }
      return a.Descricao.localeCompare(b.Descricao);
    });
  }



  selecionarAreas() {
    this.configurarTraducao();
    this.carregandoAreas = true;
    this.areaService.listarTodasAreasPorFazenda(this.fazenda.Id).subscribe(
      res => {
        this.auxAreas = res;
        this.enriquecerAreasComSetor();
        this.carregandoAreas = false;
        this.filtrarAreasIrrigado();
        this.filtrarAreasSequeiro();
      },
      err => {
        this.utils.getErro(err);
        this.carregandoAreas = false;
      });
  }

  // GLEBAS
  inserirGleba(areaId?: number) {
    if (this.FormsGleba) {
      this.FormsGleba.show(undefined, areaId);
    }
  }

  selecionarGleba(idGleba: number, areaId?: number) {
    this.configurarTraducao();
    this.carregandoAreas = true;
    this.glebaService.getGleba(idGleba).subscribe(res => {
      const gleba = res;
      this.carregandoAreas = false;
      if (this.FormsGleba) {
        this.FormsGleba.show(gleba, areaId);
      }
    },
    ex => {
      Swal.fire(this.ERRO, ex.error.ExceptionMessage, 'error');
      this.carregandoAreas = false;
    });
  }

  listarGlebas(idArea: number, descricao?: string) {
    this.configurarTraducao();
    this.gbAreaId = idArea;
    if (descricao)
      this.gbNomeArea = descricao;
    this.carregandoAreas = true;
    this.glebaService.getGlebasPorArea(idArea).subscribe(
      res => {
        this.glebas = res;
        this.carregandoAreas = false;
      },
      err => {
        this.utils.getErro(err);
        this.carregandoAreas = false;
      });
  }

  limparGleba() {
    this.gbAreaId = 0;
    this.gbNomeArea = "";
  }

  finalizarSaveGleba() {
    if (this.gbAreaId > 0) {
      this.listarGlebas(this.gbAreaId);
    }
  }

  excluirGleba(glebaId: number, nome: string) {
    this.configurarTraducao();
    Swal.fire({
      title: 'Deletar ' + nome + '?',
      text: this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
        this.carregandoAreas = true;
        this.glebaService.deleteGleba(glebaId).subscribe(
          res => {
            this.toasty.show(this.FEITO, this.GLEBA_DELETADA, 'success');
            this.listarGlebas(this.gbAreaId);
            this.carregandoAreas = false;
          },
          err => {
            Swal.fire(this.ERRO, err.message, 'error');
            this.carregandoAreas = false;
          });
      }
    });
  }

  doubleClickArea(event: Area) {
    this.selecionarArea(event.Id);
  }

  editarAreaSelecionada() {
    let areaSelecionada: Area;
    if (this.gridAreasIrrigado) {
      const selecionadas = this.gridAreasIrrigado.getSelectedRecords() as Area[];
      if (selecionadas && selecionadas.length > 0) {
        areaSelecionada = selecionadas[0];
      }
    }
    if (!areaSelecionada && this.gridAreasSequeiro) {
      const selecionadas = this.gridAreasSequeiro.getSelectedRecords() as Area[];
      if (selecionadas && selecionadas.length > 0) {
        areaSelecionada = selecionadas[0];
      }
    }
    if (areaSelecionada) {
      this.selecionarArea(areaSelecionada.Id);
    } else {
      this.utils.handleWarning('Selecione uma área para editar');
    }
  }

  excluirAreaSelecionada() {
    let areaSelecionada: Area;
    if (this.gridAreasIrrigado) {
      const selecionadas = this.gridAreasIrrigado.getSelectedRecords() as Area[];
      if (selecionadas && selecionadas.length > 0) {
        areaSelecionada = selecionadas[0];
      }
    }
    if (!areaSelecionada && this.gridAreasSequeiro) {
      const selecionadas = this.gridAreasSequeiro.getSelectedRecords() as Area[];
      if (selecionadas && selecionadas.length > 0) {
        areaSelecionada = selecionadas[0];
      }
    }
    if (areaSelecionada) {
      this.excluirArea(areaSelecionada.Id, areaSelecionada.Descricao);
    } else {
      this.utils.handleWarning('Selecione uma área para excluir');
    }
  }

  confirmaRemoverAreas(irrigado: boolean): void {
    if (!this.utils.verificarPermissaoUsuario('ExcluirArea')) {
      return;
    }

    const grid = irrigado ? this.gridAreasIrrigado : this.gridAreasSequeiro;
    const tipo = irrigado ? 'irrigados' : 'sequeiro';

    if (!grid) {
      this.utils.handleWarning(`Selecione um ou mais talhões ${tipo} para continuar`);
      return;
    }

    const selecionadas = grid.getSelectedRecords() as Area[];

    if (!selecionadas || !selecionadas.length) {
      this.utils.handleWarning(`Selecione um ou mais talhões ${tipo} para continuar`);
      return;
    }

    this.configurarTraducao();

    Swal.fire({
      title: 'Você tem certeza desta ação?',
      text: 'Os talhões selecionados serão excluídos, esta ação não poderá ser desfeita!',
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
      if (!willDelete.dismiss) {
        this.removerAreas(selecionadas);
      }
    });
  }

  removerAreas(areas: Area[]): void {
    this.removendoAreas = true;
    this.areaService.deleteAreas(areas.map(p => p.Id)).subscribe(
      res => {
        // Se o backend devolver dicionário de erros (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const area = areas.find(a => a.Id.toString() === id);
            const nomeArea = area ? area.Descricao : `ID ${id}`;
            erros.push(`<b>${nomeArea}</b>: ${res[id]}`);
          });

          Swal.fire({
            title: 'Erro ao excluir talhões',
            html: `Os seguintes talhões não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          this.utils.handleSuccess('Talhões excluídos com sucesso');
        }

        this.listarAreas(this.fazenda.Id);
        this.removendoAreas = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendoAreas = false;
      });
  }

  confirmaInativarAreas(irrigado: boolean): void {
    const grid = irrigado ? this.gridAreasIrrigado : this.gridAreasSequeiro;
    const tipo = irrigado ? 'irrigados' : 'sequeiro';

    if (!grid) {
      this.utils.handleWarning(`Selecione um ou mais talhões ${tipo} para continuar`);
      return;
    }

    const selecionadas = grid.getSelectedRecords() as Area[];

    if (!selecionadas || !selecionadas.length) {
      this.utils.handleWarning(`Selecione um ou mais talhões ${tipo} para continuar`);
      return;
    }

    const todasInativas = selecionadas.every(a => a.Ativo === false);
    const algumaInativa = selecionadas.some(a => a.Ativo === false);

    if (todasInativas) {
      this.utils.handleWarning(`Todos os talhões ${tipo} selecionados já estão inativos`);
      return;
    }

    let texto = `Os talhões ${tipo} selecionados serão inativados!`;
    if (algumaInativa) {
      texto += '<br> Alguns talhões já estão inativos e serão ignorados.';
    }

    Swal.fire({
      title: 'Você tem certeza desta ação?',
      html: texto,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Inativar talhões',
    }).then((response) => {
      if (!response.dismiss) {
        const ativas = selecionadas.filter(a => a.Ativo === true);
        this.inativarAreas(ativas);
      }
    });
  }

  inativarAreas(areas: Area[]): void {
    this.inativandoAreas = true;
    this.areaService.inativar(areas.map(p => p.Id))
      .subscribe(
        () => {
          this.utils.handleSuccess('Talhões inativados com sucesso');
          this.listarAreas(this.fazenda.Id);
          this.selecionarAreas();
          this.inativandoAreas = false;
        },
        (err) => {
          this.utils.getErro(err);
          this.inativandoAreas = false;
        }
      );
  }
}

